const _ = require('lodash');
const UrlInfo = require('../../olycommon/urlinfo/url-info');

let _api, _browseApi, _detailProductService, _trolleyService;

const ShelfProductService = function ShelfProductService(Restangular, detailProductService, trolleyService) {
    _api = Restangular.all('products');
    _detailProductService = detailProductService;
    _trolleyService = trolleyService;
    _browseApi = Restangular.one('browse');
};

/*
 * Calls /products/<stockcode>
 */
ShelfProductService.prototype.getProductDetail = function (stockcode) {
    return _api.get(stockcode);
};

/*
 * Calls /products/<stockcodes>
 */
ShelfProductService.prototype.getProductsByStockcodes = function (stockcodes, excludeUnavailable, source) {
    return _api.get(stockcodes.join(), {
        excludeUnavailable: !!excludeUnavailable,
        source,
    });
};


/*
 * calls /products?filters
 */
ShelfProductService.prototype.getProducts = function (args) {
    return _api.getList(args).then((response) => {

        // At the moment we are only adding from Visual Shopping, once we introduce another
        // way to populate the products container this code will need to be re-evaluated.
        _.forEach(response, (bundle) => {
            _.forEach(bundle.Products, (product) => {
                // Set the add to trolley source for analytics.
                product.Source = 'VisualShopping';
            });
        });

        return response;
    });
};

ShelfProductService.prototype.processTrolleyProductTagLink = function (tagLink) {

    // breaks the link with the urlInfo
    const url = new UrlInfo(tagLink);
    const search = url.getSearchObject();
    const path = url.pathname();

    // Only AddToTrolley and AddMultiToTrolley should change,
    // the other tags will follow the link as usual
    if (path.indexOf('AddToTrolley') >= 0 || path.indexOf('AddMultiToTrolley') >= 0) {
        const codes = search.stockcode.split(',');
        for (let i = 0; i < codes.length; i++) {
            this.addItemToTrolley(codes[i], search.quantity, search.source);
        }

        return true;
    }

    return false;
};

ShelfProductService.prototype.addItemToTrolley = function (stockCode, quantity, source) {

    // Quantity is undefined when add multiple items to the trolley
    quantity = quantity !== undefined ? parseInt(quantity) : 1;
    return _detailProductService.getProductDetail(stockCode).then((result) => {
        const product = result.Product;
        if (product.IsInTrolley) {
            const addQuantity = product.QuantityInTrolley + quantity;
            _trolleyService.updateTrolleyItem(product, addQuantity);
        } else {
            _trolleyService.addItemToTrolley(product, quantity, source);
        }
    });
};


/*
 * calls /browse?filters
 */
ShelfProductService.prototype.getBrowsePage = function (args) {
    return _browseApi.post('category', args);
};

module.exports = ShelfProductService;



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelfproduct.service.js